import React, { useState, useEffect, useCallback } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { CancelRequest } from "../../../../../services/AxiosInstance";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../../constant/Pagination";
import TableLoaderEffect from "../../../../constant/TableLoader";
import DebounceSearchInput from "../../../../constant/DebounceSearchInput";
import { Button } from "react-bootstrap";
import {
  getDocumentSheetListApi,
  getDocumentSheetReportListApi,
} from "../../../../../services/DocumentService";
import VersionStatus from "./VersionStatus";
import { connect } from "react-redux";

const DocumentReport = ({ userPermission, user }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [query, setSearchQuery] = useState("");
  const [selectedParameters, setSelectedParameters] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({ status: "" });
  const [isLoading, setIsLoading] = useState(false);
  const recordsPerPage = 25;
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const updateActiveKey = location.state?.activekey || "document";

  const fetchData = useCallback(() => {
    CancelRequest();
    setIsLoading(true);
    getDocumentSheetReportListApi(id)
      .then((resp) => {
        setData(resp.data.results);
        setTotal(resp.data.total);
      })
      .catch((error) => {
        console.error(error.response?.data?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedParameters([]);
  };

  const handlePagination = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handleAfterUpdate = (updatedData) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === updatedData.id ? { ...item, ...updatedData } : item
      )
    );
  };

  const handleSearchChange = (value) => {
    CancelRequest();
    setSearchQuery(value);
    setCurrentPage(1);
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <div className="table-header">
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm btn-circle"
                    onClick={() => navigate("/document")}
                  >
                    <i className="fa-solid fa-arrow-left"></i>
                  </button>
                  <h4 className="mb-0 ms-2">Report</h4>
                </div>
                <div className="table-left-header">
                  <div className="form-group me-3">
                    <DebounceSearchInput
                      handleSearchChange={handleSearchChange}
                    />
                  </div>
                </div>
              </div>

              <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                <table
                  id="empoloyees-tblwrapper"
                  className="table ItemsCheckboxSec dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th>Parameter</th>
                      <th>Actual Value</th>
                      <th>Expected Value</th>
                      <th>Created At</th>
                      <th>File</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <TableLoaderEffect colLength={7} />
                    ) : (
                      data.map((checklist) =>
                        checklist?.checklists.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.parameter?.parameter_name}</td>
                            <td>{item?.actual_value}</td>
                            <td>{item?.parameter?.expected_value}</td>
                            <td>{item?.created_at}</td>
                            <td>
                              {item?.evidence_file ? (
                                <Button
                                  variant="info"
                                  className="btn-sm"
                                  href={`${process.env.REACT_APP_BASE_URL}${item?.evidence_file}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i className="fa-solid fa-file-arrow-down me-2"></i>
                                  View File
                                </Button>
                              ) : (
                                "No file"
                              )}
                            </td>
                          </tr>
                        ))
                      )
                    )}
                  </tbody>
                </table>
              </div>

              {isLoading ? (
                <div style={{ height: "4rem" }}></div>
              ) : (
                <Pagination
                  currentPage={currentPage}
                  recordsPerPage={recordsPerPage}
                  dataLength={total}
                  handlePagination={handlePagination}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} size="sm" onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Parameter Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
            <table
              id="empoloyees-tblwrapper"
              className="table ItemsCheckboxSec dataTable no-footer mb-0"
            >
              <thead>
                <tr>
                  <th>Parameter</th>
                  <th>Expected Value</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <TableLoaderEffect colLength={5} />
                ) : (
                  selectedParameters.map((param, index) => (
                    <tr key={index}>
                      <td>{param.parameter_name}</td>
                      <td>{param.expected_value}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  userPermission: state.auth.user?.test_evaluation_permission,
  user: state.auth.user,
});
export default connect(mapStateToProps)(DocumentReport);
